// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-chocolat-js": () => import("./../../../src/pages/chocolat.js" /* webpackChunkName: "component---src-pages-chocolat-js" */),
  "component---src-pages-contact-js": () => import("./../../../src/pages/contact.js" /* webpackChunkName: "component---src-pages-contact-js" */),
  "component---src-pages-glace-js": () => import("./../../../src/pages/glace.js" /* webpackChunkName: "component---src-pages-glace-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-pain-js": () => import("./../../../src/pages/pain.js" /* webpackChunkName: "component---src-pages-pain-js" */),
  "component---src-pages-patisserie-js": () => import("./../../../src/pages/patisserie.js" /* webpackChunkName: "component---src-pages-patisserie-js" */),
  "component---src-pages-traiteur-js": () => import("./../../../src/pages/traiteur.js" /* webpackChunkName: "component---src-pages-traiteur-js" */)
}

